import { render, staticRenderFns } from "./CCDetail.vue?vue&type=template&id=0ff41348&"
import script from "./CCDetail.vue?vue&type=script&lang=js&"
export * from "./CCDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports